import Column from '@amzn/meridian/column';
import React from 'react';

import { CCXNegOneboxDataCheck } from '../helper';
import { DisplaySubMetricsProps } from '../types';
import CCXSubMetricComponent from './CCXSubMetricComponent';
import NoSubMetric from './Util/NoSubMetric';

const DisplayCCXNegativeOneboxSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.CCX_NEG_ONEBOX?.submetrics) {
    return <></>;
  }
  if (CCXNegOneboxDataCheck(metrics.CCX_NEG_ONEBOX?.submetrics!)) {
    return <NoSubMetric />;
  }
  const {
    negativeOneboxEmpathy,
    negativeOneboxCourtesy,
    negativeOneboxKnowledgeable,
    negativeOneboxUnderstandability,
    negativeOneboxHelpfulness,
    negativeOneboxEfficiency,
  } = metrics.CCX_NEG_ONEBOX?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {negativeOneboxEmpathy && (
        <CCXSubMetricComponent
          metric={negativeOneboxEmpathy}
          titleStringId='cs_perfportal_lighthouse_empathy'
          titleDefaultMessage='Empathy'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxEmpathy_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Empathy” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeOneboxCourtesy && (
        <CCXSubMetricComponent
          metric={negativeOneboxCourtesy}
          titleStringId='cs_perfportal_lighthouse_courtesy'
          titleDefaultMessage='Courtesy'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxCourtesy_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Courtesy” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeOneboxKnowledgeable && (
        <CCXSubMetricComponent
          metric={negativeOneboxKnowledgeable}
          titleStringId='cs_perfportal_lighthouse_knowledgeable'
          titleDefaultMessage='Knowledgeable'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxKnowledgeable_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Knowledgeable” CCX rating.'
        />
      )}
      {negativeOneboxUnderstandability && (
        <CCXSubMetricComponent
          metric={negativeOneboxUnderstandability}
          titleStringId='cs_perfportal_lighthouse_understandability'
          titleDefaultMessage='Understandability'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxUnderstandability_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Easy to Understand” CCX rating.'
        />
      )}
      {negativeOneboxHelpfulness && (
        <CCXSubMetricComponent
          metric={negativeOneboxHelpfulness}
          titleStringId='cs_perfportal_lighthouse_helpfulness'
          titleDefaultMessage='Helpfulness'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxHelpfulness_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Helpfulness” Customer Contact Experience (CCX) rating.'
        />
      )}
      {negativeOneboxEfficiency && (
        <CCXSubMetricComponent
          metric={negativeOneboxEfficiency}
          titleStringId='cs_perfportal_lighthouse_efficiency'
          titleDefaultMessage='Efficiency'
          definitionStringId='cs_perfportal_lighthouse_negativeOneboxEfficiency_def'
          definitionDefaultMessage='Percentage of 1-star responses to the “Efficiency” Customer Contact Experience (CCX) rating.'
        />
      )}
    </Column>
  );
};

export default DisplayCCXNegativeOneboxSubMetrics;
